import { render } from "./PrintReceipt.vue?vue&type=template&id=21c9851e&scoped=true"
import script from "./PrintReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReceipt.vue?vue&type=script&lang=js"

import "./PrintReceipt.vue?vue&type=style&index=0&id=21c9851e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c9851e"]])

export default __exports__